import { Application, RENDERER_TYPE, DisplayObject } from 'pixi.js'
import { PixiPlugin } from 'gsap/PixiPlugin'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import gsap from 'gsap'
import { ColorMatrixFilter } from 'pixi.js'
import input from '@/scripts/canvas/Input'
import { isMobile } from '@/scripts/helpers/features'

let app: Application | undefined
let sceneParked = false

export function getApp(): Application | undefined {
  return app
}

export function setApp(newApp: Application | undefined): void {
  app = newApp
}

export function parkScene(): void {
  if (!app || sceneParked) return
  sceneParked = true

  app.stop()
  try {
    gsap.ticker.sleep?.()
  } catch {
    // GSAP ticker may not be available
  }

  try {
    input.stop()
  } catch {
    // Input may not be initialized
  }
  // keep audio running across mode switches for seamlessness
}

export function resumeScene(): void {
  if (!app || !sceneParked) return
  sceneParked = false

  try {
    gsap.ticker.wake?.()
  } catch {
    // GSAP ticker may not be available
  }
  app.start()
  try {
    input.start()
  } catch {
    // Input may not be initialized
  }
}

export function initApp(): Application {
  app = new Application({
    antialias: false,
    backgroundAlpha: 0,
    resolution: window.devicePixelRatio || 1,
    view: document.querySelector('.canvas-container canvas') as HTMLCanvasElement,
    backgroundColor: 0xffffff,
    autoDensity: true,
  })
  app.stage.eventMode = 'static'
  ;(globalThis as { __PIXI_APP__?: Application }).__PIXI_APP__ = app
  return app
}

export function registerPlugins(): void {
  gsap.registerPlugin(PixiPlugin)
  gsap.registerPlugin(MotionPathPlugin)
  PixiPlugin.registerPIXI({
    DisplayObject,
    filters: { ColorMatrixFilter },
  })
}

export function isLowEnd(): boolean {
  return app?.renderer.type !== RENDERER_TYPE.WEBGL || isMobile
}
